module.exports = new __parcel__URL__("cloudform.f6fe495f.png").toString();